var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.158 1.786-.928.928a.563.563 0 0 0 0 .796L14.7 12l-8.47 8.49a.563.563 0 0 0 0 .796l.928.928c.22.22.576.22.796 0l9.816-9.816a.56.56 0 0 0 0-.796L7.954 1.786a.56.56 0 0 0-.796 0"
  })));
};
export default SvgChevronRight;